import { Dropdown, MenuProps } from 'antd';
import { ReactNode } from 'react';
import { FiMoreVertical } from 'react-icons/fi';

type RowAction = {
    key: string;
    label: string;
    icon?: ReactNode;
    onClick: (row: any) => void;
    disabled?: boolean;
};

type RowActionsMenuProps = {
    dataRow: any;
    actions: RowAction[];
};

export const RowActionsMenu = ({ dataRow, actions }: RowActionsMenuProps) => {
    const menuItems: MenuProps['items'] = actions.map((action) => ({
        key: action.key,
        label: action.label,
        icon: action.icon,
        disabled: action.disabled,
        className: '!px-4 !py-2 !font-normal !text-black-primary',
    }));

    const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
        const action = actions.find((a) => a.key === key);
        if (action) {
            action.onClick(dataRow);
        }
    };

    return (
        <div
            className="flex justify-center items-center w-full h-full"
            style={{ padding: 0, margin: 0 }}
            onClick={(e) => e.stopPropagation()}
        >
            <Dropdown
                trigger={['click']}
                menu={{ items: menuItems, onClick: handleMenuClick }}
            >
                <button
                    className="flex items-center justify-center w-12 h-12 p-0 m-0"
                    style={{
                        lineHeight: 0,
                        border: 'none',
                        background: 'transparent',
                    }}
                >
                    <FiMoreVertical size={18} />
                </button>
            </Dropdown>
        </div>
    );
};
